import { Tracer } from './tracer.js';
import { FrontendLogger } from './logger.js';
function make_node_hexrandom(crypto) {
    return function genBytes(n) {
        return crypto.randomBytes(n).toString('hex');
    };
}
function make_bumping_timestamper() {
    let last = Date.now() * 1000;
    return () => {
        last = Math.max(last + 1, Date.now() * 1000);
        return last;
    };
}
function make_frontend_hexrandom(crypto) {
    return function (n) {
        const bytes = crypto.getRandomValues(new Uint8Array(n));
        const array = Array.from(bytes);
        const hexPairs = array.map((b) => b.toString(16).padStart(2, '0'));
        return hexPairs.join('');
    };
}
export function createFrontendTracer(opts) {
    if (!opts.crypto) {
        throw new Error('frontend tracer must supply Crypto');
    }
    if (!opts.fetch) {
        throw new Error('frontend tracer must supply Fetch');
    }
    if (!opts.url) {
        throw new Error('frontend tracer must supply Logger url');
    }
    return new Tracer({
        type: 'frontend',
        hexrandom: make_frontend_hexrandom(opts.crypto),
        logger: new FrontendLogger(opts.fetch, opts.url, !opts.enabled),
        timestamper: make_bumping_timestamper(),
    });
}
export function createCLITracer(opts) {
    if (!opts.crypto) {
        throw new Error('cli tracer must supply Crypto');
    }
    if (!opts.fetch) {
        throw new Error('cli tracer must supply Fetch');
    }
    if (!opts.url) {
        throw new Error('cli tracer must supply Logger url');
    }
    return new Tracer({
        type: 'cli',
        hexrandom: make_frontend_hexrandom(opts.crypto),
        logger: new FrontendLogger(opts.fetch, opts.url),
        timestamper: make_bumping_timestamper(),
    });
}
export function createNodeTracer(opts) {
    if (!opts.logger) {
        throw new Error('backend tracer must supply logger (pino)');
    }
    if (!opts.crypto) {
        throw new Error('cli tracer must supply Crypto');
    }
    return new Tracer({
        type: 'backend',
        logger: opts.logger,
        hexrandom: opts.hexrandom || make_node_hexrandom(opts.crypto),
        timestamper: opts.timestamper || make_bumping_timestamper(),
    });
}
